import styled from 'styled-components';

import Icon from '@klv/atoms/icon';
import Typography from '@klv/atoms/typography';
import type { ICustomThemeProps } from '@klv/shared/styles/themes/styled';
import type { IAccordionRowIcon } from '../types';

export const toggleSpeed = 350;
export const closeDelay = 50;

export const AccordionTitle = styled.button`
  border: 0;
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1.6rem 0;
  margin: 0;
  cursor: pointer;
  text-align: left;
  color: inherit;
  &:focus-visible  {
    outline-offset: 3px; 
    outline: 1px dashed currentColor;
  }
`;

export const AccordionContent = styled.div<{ $isExpanded: boolean; $variant: string; }>`
  display: none;
  color: ${({ theme, $variant }) => theme.accordion[$variant as keyof ICustomThemeProps['accordion']].text};
  max-height: 0px;
  overflow: hidden;
  transition-property: all;
  transition-timing-function: ease-out;
  transition-duration: ${toggleSpeed}ms;
  @media (prefers-reduced-motion) {
    transition-duration: 0s;
  }
`;

export const ButtonWrapper = styled.div`
  padding-bottom: 4rem;
`;

export const MediaWrapper = styled.div`
  padding-bottom: 1.4rem;
  
  ${({ theme }) => theme.screenSize.s768.mediaQuery} {
    display: none;
  }
`;

export const InlineMediaWrapper = styled.div`
  padding-bottom: 1.4rem;
  text-align: center;
`;

export const StyledIcon = styled(Icon)<IAccordionRowIcon>`
  color: ${({ theme, $variant }) => theme.accordion[$variant as keyof ICustomThemeProps['accordion']].expandCollapseIcon};
  flex-shrink: 0;
  margin-left: 0.5em;
  transform: ${({ $isExpanded }) => `rotate(${$isExpanded ? '180deg' : '0deg'})`};  
  transition-timing-function: ${({ theme }) => theme.transition.easingFunction};
  transition-duration: ${({ theme }) => `${theme.transition.duration}s`};
  transition-delay: 0.1s;

  path {
    fill: currentColor;
  }
`;

export const StyledTypography = styled(Typography)`
  padding-bottom: 2em;
  padding-top: 0.2em;
`;

export const StyledHeadline = styled(Typography)``;

export const AccordionRow = styled.div<{ $hasBorder: number; $variant: string; }>`
  ${({ $hasBorder, $variant, theme }) => `
    padding: 1.6rem 0;
    ${$hasBorder ? `border-top: 1px solid ${theme.accordion[$variant as keyof ICustomThemeProps['accordion']].rowBorderColor}` : ''};
  `}
`;
